let apiaddress = 'http://hyapi.wk4hydjl.com';

switch(process.env.VUE_APP_MODE){
    case 'uat':
        apiaddress = 'http://hyapi.wk4hydjl.com';
        // apiaddress = 'https://api.byrvolgv.com';
        break;
    case 'production':
        apiaddress = 'https://api.byrvolgv.com';
        break;
}
// switch(process.env.VUE_APP_MODE) {
//   case 'uat':
//     apiaddress = 'https://api.porn3.app';
//     break;
//   case 'production':
//     apiaddress = 'https://api.bttzyw100.com';
//     apiaddress = 'https://api.yvf19ts7.com';
//     break;
// }

export default apiaddress;
